import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function NftMarketplace() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleItem = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    // light dark change image

    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const currentTheme =
            document.documentElement.getAttribute("data-theme") || "light";
        setTheme(currentTheme);

        const observer = new MutationObserver(() => {
            const newTheme =
                document.documentElement.getAttribute("data-theme") || "light";
            setTheme(newTheme);
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-theme"],
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Helmet>
                <title>NFT Marketplace Development Services | Blockcryp</title>
                <meta
                    name="description"
                    content="Launch your own NFT marketplace with Blockcryp. We offer custom NFT platform development with wallet integration, minting, auctions, and smart contract support."
                />
                <meta
                    name="keywords"
                    content=" NFT marketplace development, custom NFT platform, NFT website development, white label NFT marketplace, NFT smart contract development, NFT minting platform, NFT auction platform, NFT wallet integration, blockchain NFT solutions, NFT marketplace development company"
                />
            </Helmet>
            {/* ---------- hero section start ---------- */}
            <section className="space80">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h1
                                className="heading_h1 fw-bold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                NFT Marketplace Development
                            </motion.h1>
                            <motion.p
                                className="pera_txt"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                Build intelligent, scalable NFT marketplaces with Blockcryp—where decentralized commerce meets AI-powered user experiences. Trusted by global enterprises, solutions offered by our NFT marketplace development company are engineered for longevity, liquidity, and market leadership.
                            </motion.p>

                            <button class="button theme_btn mt-lg-4 mt-0" type="submit">
                                View Live Demo
                            </button>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/nftmarketplace/nft_hero.webp"
                                    alt="Image 1"
                                    className="w-100"
                                />
                                {/* <img
                                    src="assets/images/nftmarketplace/nft_hero.webp"
                                    alt="token hero"
                                    className="w-100"
                                /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Future-Proof Agility section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-6 col-xl-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/nftmarketplace/proof.webp"
                                    alt="Image 1"
                                    className="w-100"
                                />
                            </motion.div>
                            {/* <motion.img
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                src="assets/images/nftmarketplace/proof.webp" alt="" className="w-100 pe-0 pe-lg-5" /> */}
                        </div>
                        <div className="col-lg-6 col-xl-6">
                            <motion.div
                                className="mb-5"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h2 className="heading_h3 fw-bold mb-4 text-xl-start">
                                    Enterprise-Grade NFT Marketplaces with Future-Proof Agility
                                </h2>
                                <p>Blockcryp excels in highly secured, scalable, and interoperable trading platforms on blockchain and AI, having profuse experience in creating NFT marketplace solutions. Our NFT marketplace development services include multi-chain support, dynamic royalty configuration, bespoke smart contract logic, and token standards to ensure that assets can be tokenized and liquified on multiple platforms for ease of transaction. Real-time analytics dashboards and modular architecture add to the cool features of our NFT marketplace development company developed for enterprise purposes and future scalability.</p>
                                <button class="button theme_btn mt-lg-4 mt-0" type="submit">
                                    Connect on Telegram
                                </button>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- NFT Marketplace Solutions section start ---------- */}
            {/* <section className="why_choose_defi space60">
                <div className="container">
                    <div className="row align-items-center justify-content-between g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-bold"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Exceptional Features of our NFT Marketplace Platform Development Solutions</motion.h3>
                                <motion.p
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >In the evolving NFT ecosystem, where innovation is paramount, Blockcryp stands as a beacon of impeccability. As a global leader in the NFT marketplace platform development space, we fuse cutting-edge technologies where NFT marketplaces are equipped with exceptional features to deliver an unparalleled experience.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                ><i class="fa-solid fa-circle-check pe-2"></i><b>NFT Token Standards Support : </b>Blockcryp's NFT marketplace development solutions support a comprehensive range of token standards including ERC 721 and ERC-1155 while ensuring robust compatibility with multiple blockchain ecosystems.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                ><i class="fa-solid fa-circle-check pe-2"></i><b>NFT Auctioning : </b> Grab the attention of your potential customers with dynamic NFT auctions where the NFT marketplaces are powered with a feature-rich auction system, allowing creators and collectors to interact seamlessly.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                ><i class="fa-solid fa-circle-check pe-2"></i><b>Transactional History : </b> Blockcryp offers comprehensive transactional history tracking that enables users to trace the provenance and ownership of NFTs in a hassle-free manner.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                ><i class="fa-solid fa-circle-check pe-2"></i><b>Royalty : </b> Our NFT marketplace platform development solutions automate royalty distribution assuring that creators and artists get recognition and enjoy additional benefits from the resale of their creations.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                ><i class="fa-solid fa-circle-check pe-2"></i><b>Interoperability : </b> Our ready-to-deploy NFT development solutions are crafted with interoperability in mind, ensuring seamless integration with third-party platforms.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                ><i class="fa-solid fa-circle-check pe-2"></i><b>Secure Wallet Integration : </b> Delivering a frictionless experience across robust wallet integration that assures the utmost safety of users' digital assets in the long run.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                ><i class="fa-solid fa-circle-check pe-2"></i><b>Cost-Efficient Architecture : </b> Our architecture is crafted in such a way as to minimize gas fees, making NFT minting and trading accessible to a wider target audience.</motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img src="assets/images/nftmarketplace/solution.webp" alt="" className="w-100 ps-0 ps-lg-5" />
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section> */}
            {/* ---------- NFT Marketplace Services section start ---------- */}
            <section className="space60 services">
                <div className="container">
                    <div className="row justify-content-center mb-4 mb-lg-5">
                        <div className="col-12 mt-0 mb-3">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold"
                            >
                                NFT Marketplace Development <br className="d-md-block d-none" /> Services
                            </ScrollFloat>
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >With Blockcryp’s certified and top NFT marketplace developers, it will be a smooth and flawless experience to build an NFT marketplace from scratch. Our NFT marketplace company produces a ready-to-deploy platform framework that provides indefinite scalability. Our experts make it easier for enterprises to create their marketplace dashboard with pick & drop of features.</motion.p>
                        </div>
                    </div>
                    <div className="row justify-content-center g-4">
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/nftmarketplace/ser1-dark.svg"
                                            : "assets/images/nftmarketplace/ser1-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold">NFT Consultation</h5>
                                <p>We have a dexterous team of NFT consultants and advisors who can guide you throughout your NFT journey and assist you with tailored NFT marketplace development solutions.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/nftmarketplace/ser2-dark.svg"
                                            : "assets/images/nftmarketplace/ser2-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold">Decentralized NFT Marketplace Development</h5>
                                <p>Provide more power in the hands of your platform users with our decentralized NFT marketplace development services.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/nftmarketplace/ser3-dark.svg"
                                            : "assets/images/nftmarketplace/ser3-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Metaverse NFT Marketplace Development</h5>
                                <p className="mb-0">
                                    We help you to build an NFT marketplace that is fully customized, engaging, and interactive for Metaverse NFTs with unique features & functionalities.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/nftmarketplace/ser4-dark.svg"
                                            : "assets/images/nftmarketplace/ser4-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">NFT Smart Contract Development</h5>
                                <p className="mb-0">
                                    We are good at coding smart contracts and performing auditing. Each smart contract is carefully tested and debugged before deployment.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/nftmarketplace/ser5-dark.svg"
                                            : "assets/images/nftmarketplace/ser5-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">NFT Development</h5>
                                <p className="mb-0">
                                    Our skilled developers can add a token creation feature as a service to your NFT marketplace. You can enable the users to tokenize their assets.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/nftmarketplace/ser6-dark.svg"
                                            : "assets/images/nftmarketplace/ser6-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">NFT Wallet Development</h5>
                                <p className="mb-0">
                                    We offer a decentralized NFT Storage Solution that makes it easier for you to store your NFT data, including audio, video and images on IPFS.
                                </p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- User Experiences section start ---------- */}
            <section className="space80 overflow-hidden">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <div className="row justify-content-center">

                                <motion.h2
                                    className="heading_h3 fw-bold mb-4 p-0 text-start"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    AI-Native NFT Ecosystems Optimized for Adaptive User Experiences
                                </motion.h2>
                                <motion.p
                                    className="text-start"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Blockcryp has redefined the NFT marketplace platform development by combining blockchain power with AI-native intelligence to create adaptive, insight-driven ecosystems. Our platforms are built to learn and evolve through user behavior analytics, sentiment modeling, and intelligent automation—offering hyper-personalized experiences, optimized trading settings, and predictive engagement loops.
                                </motion.p>
                                <div className="col-sm-6">
                                    <motion.div
                                        className="how_card position-relative d-flex align-items-center gap-3"
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <img
                                            src={
                                                theme === "dark"
                                                    ? "assets/images/nftmarketplace/ant1-dark.svg"
                                                    : "assets/images/nftmarketplace/ant1-light.svg"
                                            }
                                            alt="Logo"
                                        />
                                        <h5 className="text_16 fw-semibold mb-0">Predictive personalization</h5>
                                    </motion.div>
                                </div>
                                <div className="col-sm-6">
                                    <motion.div
                                        className="how_card position-relative d-flex align-items-center gap-3"
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <img
                                            src={
                                                theme === "dark"
                                                    ? "assets/images/nftmarketplace/ant2-dark.svg"
                                                    : "assets/images/nftmarketplace/ant2-light.svg"
                                            }
                                            alt="Logo"
                                        />
                                        <h5 className="text_16 fw-semibold mb-0">Sentiment analysis</h5>
                                    </motion.div>
                                </div>
                                <div className="col-sm-6">
                                    <motion.div
                                        className="how_card position-relative d-flex align-items-center gap-3"
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <img
                                            src={
                                                theme === "dark"
                                                    ? "assets/images/nftmarketplace/ant3-dark.svg"
                                                    : "assets/images/nftmarketplace/ant3-light.svg"
                                            }
                                            alt="Logo"
                                        />
                                        <h5 className="text_16 fw-semibold mb-0">Dynamic pricing models</h5>
                                    </motion.div>
                                </div>
                                <div className="col-sm-6">
                                    <motion.div
                                        className="how_card position-relative d-flex align-items-center gap-3"
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <img
                                            src={
                                                theme === "dark"
                                                    ? "assets/images/nftmarketplace/ant4-dark.svg"
                                                    : "assets/images/nftmarketplace/ant4-light.svg"
                                            }
                                            alt="Logo"
                                        />
                                        <h5 className="text_16 fw-semibold mb-0">Intelligent search</h5>
                                    </motion.div>
                                </div>
                                <div className="col-sm-6">
                                    <motion.div
                                        className="how_card position-relative d-flex align-items-center gap-3"
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <img
                                            src={
                                                theme === "dark"
                                                    ? "assets/images/nftmarketplace/ant5-light.svg"
                                                    : "assets/images/nftmarketplace/ant5-dark.svg"
                                            }
                                            alt="Logo"
                                        />
                                        <h5 className="text_16 fw-semibold mb-0">AI-powered curation</h5>
                                    </motion.div>
                                </div>
                                <div className="col-sm-6">
                                    <motion.div
                                        className="how_card position-relative d-flex align-items-center gap-3"
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <img
                                            src={
                                                theme === "dark"
                                                    ? "assets/images/nftmarketplace/ant6-dark.svg"
                                                    : "assets/images/nftmarketplace/ant6-light.svg"
                                            }
                                            alt="Logo"
                                        />
                                        <h5 className="text_16 fw-semibold mb-0">Smart fraud detection</h5>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/nftmarketplace/metaverse1.webp"
                                    alt="Image 1"
                                    className="w-100 ps-lg-5"
                                />
                            </motion.div>
                            {/* <motion.img
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                src="assets/images/nftmarketplace/metaverse1.webp"
                                alt=""
                                className="w-100 ps-5"
                            /> */}
                        </div>

                    </div>
                </div>
            </section>
            {/* ---------- Prominent Use Cases section start ---------- */}
            <section className="services space80">
                <div className="container">
                    <div className="row justify-content-center mb-4 mb-lg-5">
                        <div className="col-10">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold"
                            >
                                NFT Marketplace Development Prominent<br className="d-md-block d-none" /> Use Cases
                            </ScrollFloat>
                            <p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Blockcryp excels in delivering full-fledged NFT marketplace development solutions that are easily customizable and can be launched in less time. It’s time to get a cost estimation and discuss the possibility of future upgrades for your marketplace. Create an NFT marketplace for a diverse range of segments and industries that include:</p>
                        </div>
                    </div>
                    <ul className="row">
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case1-dark.svg"
                                                : "assets/images/nftmarketplace/case1-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">Arts & Artists</h3>
                                </div>
                            </motion.div>
                        </li>
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case2-dark.svg"
                                                : "assets/images/nftmarketplace/case2-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">Auction Houses</h3>
                                </div>
                            </motion.div>
                        </li>
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case3-dark.svg"
                                                : "assets/images/nftmarketplace/case3-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">Music</h3>
                                </div>
                            </motion.div>
                        </li>
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case4-dark.svg"
                                                : "assets/images/nftmarketplace/case4-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">Real Estate</h3>
                                </div>
                            </motion.div>
                        </li>
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case5-dark.svg"
                                                : "assets/images/nftmarketplace/case5-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">Games</h3>
                                </div>
                            </motion.div>
                        </li>
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case6-dark.svg"
                                                : "assets/images/nftmarketplace/case6-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">Generative Arts</h3>
                                </div>
                            </motion.div>
                        </li>
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case7-dark.svg"
                                                : "assets/images/nftmarketplace/case7-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">E-Commerce</h3>
                                </div>
                            </motion.div>
                        </li>
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case8-dark.svg"
                                                : "assets/images/nftmarketplace/case8-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">Domains</h3>
                                </div>
                            </motion.div>
                        </li>
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case9-dark.svg"
                                                : "assets/images/nftmarketplace/case9-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">Ticketing</h3>
                                </div>
                            </motion.div>
                        </li>
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case10-dark.svg"
                                                : "assets/images/nftmarketplace/case10-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">Metaverse</h3>
                                </div>
                            </motion.div>
                        </li>
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case11-dark.svg"
                                                : "assets/images/nftmarketplace/case11-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">Avatars</h3>
                                </div>
                            </motion.div>
                        </li>
                        <li className="col-xl-4 col-lg-6 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="categories-view nft_view"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={
                                            theme === "dark"
                                                ? "assets/images/nftmarketplace/case12-dark.svg"
                                                : "assets/images/nftmarketplace/case12-light.svg"
                                        }
                                        alt="Logo"
                                    />
                                    <h3 className="fw-semibold">Real World Assets</h3>
                                </div>
                            </motion.div>
                        </li>
                    </ul>
                </div>
            </section>
            {/* ---------- Leading Blockchains section start ---------- */}
            <section className="why_choose_defi space60">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div class="wrapper position-relative">
                                <div className="left_shadow"></div>
                                <div class="marquee marquee-wrap">
                                    <div class="marquee_group">
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead1.png" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Binance
                                            </h6>
                                        </div>
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead2.webp" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Polygon
                                            </h6>
                                        </div>
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead3.svg" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Ethereum
                                            </h6>
                                        </div>
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead4.svg" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Solana
                                            </h6>
                                        </div>
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead5.webp" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Cardano
                                            </h6>
                                        </div>
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead6.webp" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Polkadot
                                            </h6>
                                        </div>
                                    </div>
                                    <div aria-hidden="ture" class="marquee_group">
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead1.png" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Binance
                                            </h6>
                                        </div>
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead2.webp" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Polygon
                                            </h6>
                                        </div>
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead3.svg" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Ethereum
                                            </h6>
                                        </div>
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead4.svg" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Solana
                                            </h6>
                                        </div>
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead5.webp" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Cardano
                                            </h6>
                                        </div>
                                        <div className="inner shadow-lg d-flex align-items-center gap-3">
                                            <img src="assets/images/nftmarketplace/lead6.webp" alt="" className="nft_slider" />
                                            <h6 className="text_16 fw-semibold m-0">
                                                Polkadot
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="right_shadow"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- faq section start ---------- */}
            <section className="space60">
                <div className="container">
                    <h2 className="heading_h3 fw-bold mb-4">Frequently Asked Questions</h2>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion">
                                <div className={`accordion__item ${activeIndex === 0 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(0)}>
                                        <span className="text_20 pe-4">
                                            1. Where can I find a NFT Marketplace Development company?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Blockcryp Solutions is a leading NFT marketplace development company that can help you build an organization to develop, issue, manage and trade non fungible tokens on the web or as a mobile application.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 1 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(1)}>
                                        <span className="text_20 pe-4">
                                            2. What is the time and cost for NFT marketplace development?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            The time and cost for building an nft marketplace completely depends on the design, features, marketplace, & development process you choose among other parameters.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 2 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(2)}>
                                        <span className="text_20 pe-4">
                                            3. Do you provide customised NFT Marketplace Development services?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Absolutely! If you are looking for NFT Marketplace development services then trust us to help you build and deploy a successful NFT marketplace to establish a corporate identity and meet your goals.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 3 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(3)}>
                                        <span className="text_20 pe-4">
                                            4. How much time will it take to develop NFT Marketplace?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            If you are looking to develop NFT marketplace then a basic plan may take anywhere from 2-3 months from the Discovery phase and will allow you to select an optimal feature set with the most suitable tech stack.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 4 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 " onClick={() => toggleItem(4)}>
                                        <span className="text_20 pe-4">
                                            5. How To Create an NFT Marketplace development platform like Opensea?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            If you are looking to create an NFT Marketplace development platform like Opensea then consult with us today to provide your users with a NFT platform to easily develop, buy and sell orders of assets from your dApp.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
